import React from 'react';
import classNames from 'classnames';

import { useConfiguration } from '../../context/configurationContext';

import css from './Logo.module.css';

export const LogoComponent = props => {
  const { className, marketplaceName, alt = '', layout = 'desktop' } = props;
  const logoClasses = className || css.root;
  const lockupClass = layout === 'mobile' ? css.lockupMobile : css.lockupDesktop;

  // Official stacked lockup: charcoal+raspberry ear-heart, pink Sweet,
  // sky-blue Listeners. Small sizes clip the PNG tagline (it downscales into
  // blue Listeners) so CSS can render LISTEN . CARE . CONNECT. in #516281.
  return (
    <div className={logoClasses}>
      <img
        className={classNames(css.lockup, lockupClass)}
        src="/static/branding/sweet-listeners-original-logo.png"
        alt={alt || marketplaceName}
      />
    </div>
  );
};

/**
 * This component returns a logo
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own css.root
 * @param {string?} props.rootClassName overwrite components own css.root
 * @param {('desktop' | 'mobile')} props.layout
 * @param {string?} props.alt alt text for logo image
 * @returns {JSX.Element} logo component
 */
const Logo = props => {
  const config = useConfiguration();
  const { layout = 'desktop', ...rest } = props;

  return <LogoComponent {...rest} layout={layout} marketplaceName={config.marketplaceName} />;
};

export default Logo;
